import * as React from 'react';
import { FormControl, DropdownButton, MenuItem } from 'react-bootstrap';
import MaskedInput from "react-maskedinput";
import { IInactiveDonor } from './inactive-donor';
import { IValidationError } from './validation-error';
import { DonorAction } from './donor-action';
import * as moment from 'moment';

interface IProps {
    data: IInactiveDonor,
    index: number,
    error: IValidationError,
    disableActions: boolean,
    onUpdateAction: (donorId: number, action: DonorAction) => void,
    onDateFocus: (donorId: number, e: React.FocusEvent<any>) => void,
    onDateChange: (donorId: number, e: React.FormEvent<any>) => void,
    onDateBlur: (donorId: number, e: React.FormEvent<any>) => void
}

class Row extends React.Component<IProps, {}> {
    getActionButtonStyle = () => {
        if (this.props.data.action == DonorAction.Update)
            return 'primary';

        if (this.props.data.action == DonorAction.Delete)
            return 'danger';

        return 'default';
    }

    render = () => {
        const action = DonorAction[this.props.data.action];

        return (
            <>
                {this.props.error != undefined && (
                    <tr>
                        <td colSpan={7} className='bg-danger text-danger' style={{ borderTop: '0 none' }}>
                            {this.props.error.messages.map((message, index) =>
                                <div key={index}>{message}</div>
                            )}
                        </td>
                    </tr>
                )}

                <tr>
                    <td>{this.props.data.alias}</td>
                    <td>{this.props.data.birthDate}</td>
                    <td>{this.props.data.evaluationDate}</td>
                    <td>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <FormControl
                                type="date"
                                name="donationStartDate"
                                style={{ width: 140, borderColor: this.props.error ? '#a94442' : '#ccc' }}
                                min={moment().format("YYYY-MM-DD")}
                                value={
                                    this.props.data.donationStartDate
                                        ? moment(this.props.data.donationStartDate, "MM/DD/YYYY").format("YYYY-MM-DD")
                                        : ""
                                }
                                onFocus={(e: React.FocusEvent<any>) =>
                                    this.props.onDateFocus(this.props.data.id, e)
                                }
                                onChange={(e: React.FormEvent<any>) =>
                                    this.props.onDateChange(this.props.data.id, e)
                                }
                                onBlur={(e: React.FormEvent<any>) =>
                                    this.props.onDateBlur(this.props.data.id, e)
                                }
                            />


                        </div>
                    </td>
                    <td>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <FormControl
                                type="date"
                                name="donationEndDate"
                                style={{ width: 140, borderColor: this.props.error ? '#a94442' : '#ccc' }}
                                min={moment().format("YYYY-MM-DD")}
                                value={
                                    this.props.data.donationEndDate
                                        ? moment(this.props.data.donationEndDate, "MM/DD/YYYY").format("YYYY-MM-DD")
                                        : ""
                                }
                                onFocus={(e: React.FocusEvent<any>) =>
                                    this.props.onDateFocus(this.props.data.id, e)
                                }
                                onChange={(e: React.FormEvent<any>) =>
                                    this.props.onDateChange(this.props.data.id, e)
                                }
                                onBlur={(e: React.FormEvent<any>) =>
                                    this.props.onDateBlur(this.props.data.id, e)
                                }
                            />
                        </div>
                    </td>
                    <td>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <DropdownButton
                                id={'action-' + this.props.data.id}
                                title={action}
                                bsStyle={this.getActionButtonStyle()}
                                onSelect={(key: any) => this.props.onUpdateAction(this.props.data.id, key)}
                                disabled={this.props.disableActions}
                            >
                                <MenuItem eventKey={0}>- select -</MenuItem>
                                <MenuItem eventKey={1}>Update</MenuItem>
                                <MenuItem eventKey={2}>Delete</MenuItem>
                            </DropdownButton>
                        </div>
                    </td>
                </tr>
            </>
        );
    }
}

export default Row;